import { BROWSER_GLOBALS_PROVIDERS } from "./utils/browser-globals";
import { ModuleWithProviders, NgModule } from "@angular/core";

import { LocaleModule } from "./locale/locale.module";
import { UtilsModule } from "./utils/utils.module";
import { HttpClientModule } from "@angular/common/http";
import { ReduxModule } from "./redux/redux.module";
import { ResourcesResolve } from "./resolve/resources.resolve";
import { DirectiveModule } from "./directive/directive.module";
import { FormatterModule } from "./formatter/formatter.module";
import { SupportLinksResolve } from "./resolve/support-link.resolve";
import { StatusResolve } from "./resolve/status.resolve";

@NgModule({
  imports: [
    LocaleModule,
    UtilsModule,
    FormatterModule,
    DirectiveModule,
    HttpClientModule,
    ReduxModule
  ],
  exports: [
    LocaleModule,
    UtilsModule,
    FormatterModule,
    DirectiveModule,
    HttpClientModule,
    ReduxModule
  ],
  providers: [
    BROWSER_GLOBALS_PROVIDERS
  ]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        BROWSER_GLOBALS_PROVIDERS,
        ResourcesResolve,
        SupportLinksResolve,
        StatusResolve
      ]
    };
  }
}
